import { TableCell, TableRow } from '@material-ui/core';
import QtyNumber from './QtyNumber';
import { formatMoney } from '../../../utils';
import { ticketCalc } from '../helpers';
import { InfoOutlinedIcon } from '../../../icons';
import { useState } from 'react';
import moment from 'moment';

function UniqueTicketRow({ u, disabled, onQtyChange, bookingItemTickets }) {
    const [showDetails, setShowDetails] = useState(false);

    let priceDisplay = '';
    // there can be multiple prices in the existing tickets, do a min-max range
    if (u.existingTickets.length > 0) {
        const minPrice = Math.min(...u.existingTickets.map(p => p.finalPrice));
        const maxPrice = Math.max(...u.existingTickets.map(p => p.finalPrice));
        priceDisplay =
            minPrice === maxPrice
                ? formatMoney(minPrice)
                : `${formatMoney(minPrice)} - ${formatMoney(maxPrice)}`;

        if (
            u.newFinalPrice != null &&
            ((minPrice === maxPrice && u.newFinalPrice !== minPrice) || minPrice !== maxPrice)
        ) {
            priceDisplay += ` (new ${formatMoney(u.newFinalPrice)})`;
        }
    } else {
        // there is no existing ticket, only new
        if (u.newFinalPrice != null) {
            priceDisplay = formatMoney(u.newFinalPrice);
        }
    }
    const { diff } = ticketCalc(u);
    return (
        <>
            <TableRow key={`u-${u.key}`}>
                <TableCell>
                    <QtyNumber
                        value={u.quantity}
                        min={0}
                        disabled={disabled}
                        onChange={onQtyChange}
                        sidebarButtons
                    />
                </TableCell>
                <TableCell align="left">{u.name}</TableCell>
                <TableCell align="right">
                    {priceDisplay}
                    <InfoOutlinedIcon
                        style={{ marginLeft: 4, opacity: 0.3, cursor: 'pointer', fontSize: 'small' }}
                        onClick={() => setShowDetails(!showDetails)}
                    />
                </TableCell>
                <TableCell align="right">{formatMoney(diff)}</TableCell>
            </TableRow>
            {showDetails && (
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell colSpan={3} style={{ backgroundColor: '#f9f9f9' }}>
                        <div style={{ padding: 16, fontSize: 14, color: '#555' }}>
                            Each ticket details:
                            <ol style={{ marginTop: 8 }}>
                                {u.existingTickets.length > 0 ? (
                                    u.existingTickets.map((t, idx) => {
                                        const matchingBookingItemTickets = bookingItemTickets.find(
                                            bit =>
                                                // this is still the booking item ticket level
                                                bit.id ===
                                                u.existingTickets[idx]?.booking_item_ticket_id
                                        );
                                        return (
                                            <li key={idx}>
                                                <b>Transaction time:</b>{' '}
                                                {moment(
                                                    matchingBookingItemTickets.created_at
                                                ).format('MMM D, YYYY h:mma')}{' '}
                                                <br />
                                                <b>Retail price per ticket:</b>{' '}
                                                {formatMoney(
                                                    matchingBookingItemTickets.retail_price
                                                )}{' '}
                                                <br />
                                                <b>Taxes and fees:</b>{' '}
                                                {formatMoney(
                                                    matchingBookingItemTickets.taxes_and_fees /
                                                        matchingBookingItemTickets.quantity
                                                )}{' '}
                                                <br />
                                                <b>Final price:</b> {formatMoney(t.finalPrice)}
                                            </li>
                                        );
                                    })
                                ) : (
                                    <li>No existing tickets.</li>
                                )}
                            </ol>
                            {u.newFinalPrice != null && (
                                <div>
                                    <hr />
                                    <b>New Ticket Price:</b> {formatMoney(u.newFinalPrice)}
                                </div>
                            )}
                        </div>
                    </TableCell>
                </TableRow>
            )}
        </>
    );
}

export default UniqueTicketRow;
